import { Navigate } from 'react-router'
import { isTestPassed } from '../../../constant/auth'

const TestGuard = ({ children }) => {
  if (!isTestPassed()) {
    return <Navigate to="/hipaa-compliance" replace />
  }
  return children
}

export default TestGuard
